<script>
  import { onMount } from "svelte";
  import AuthService from "../authService.js";
  import { navigateTo } from "svelte-router-spa";
  export let params;
  export let currentRoute;
  let email = "";
  let password = "";
  let error = null;
  let message = null;

  onMount(async () => {
    if (AuthService.isAuthenticated()) {
      navigateTo("/");
    }
  });

  async function login() {
    error = null;
    message = null;

    const response = await AuthService.login(email, password);
    if (!response.success) {
      if (response.body.code === 4) {
        error = response.body.details;
      } else {
        message = "Credenciales inválidas";
      }
    }
  }
</script>

<style>
  .centered {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>

<section id="home">
  <div class="hero-wrap">
    <div class="hero-mask opacity-6 bg-dark" />
    <div
      class="hero-bg parallax"
      style="background-image:url('images/bg/image-11.jpg');" />
    <div class="hero-content d-flex flex-column fullscreen">
      <div class="centered bg-white px-4 py-4">
        <div />
        <div class="row">
          <div class="col py-4 px-4">
            <center>
              <h3 class="pb-3">Inicio de sesión</h3>
            </center>
            {#if message}
              <div class="alert alert-danger">{message}</div>
            {/if}
            <div class="form-group row">
              <label for="inputEmail3" class="col-sm-2 col-form-label">
                Email
              </label>
              <div class="col-sm-10">
                <input
                  type="email"
                  id="inputEmail3"
                  bind:value={email}
                  class={`form-control inputs ${error && error.email ? 'is-invalid' : ''}`}
                  placeholder="Email" />
                <div class="invalid-feedback">{error && error.email}</div>
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword3" class="col-sm-2 col-form-label">
                Password
              </label>
              <div class="col-sm-10">
                <input
                  type="password"
                  class={`form-control inputs ${error && error.password ? 'is-invalid' : ''}`}
                  bind:value={password}
                  id="inputPassword3"
                  placeholder="Password" />
                <div class="invalid-feedback">{error && error.password}</div>
              </div>
            </div>


            <div class="form-group row text-center">
              <label for="inputPassword3" class="col-sm-12 col-form-label">
                ¿Olvidaste tu contraseña? <a href="/recovery">recupérala acá.</a>
              </label>
            </div>


          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-6">
            <p class="text-center">
              <button
                id="cancel-btn"
                class="btn btn-dark btn-block rounded-0 shadow-none
                justify-content-center"
                type="submit"
                on:click={() => navigateTo('/')}>
                Volver
              </button>
            </p>
          </div>
          <div class="col-md-6 col-lg-6">
            <p class="text-center">
              <button
                id="submit-btn"
                class="btn btn-primary btn-block rounded-0 shadow-none
                justify-content-center"
                on:click={login}
                type="button">
                Iniciar sesión
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
